import React from "react"

import { FormItemBase } from "./FormItem"

import type { Form as AntForm } from "antd"

export const AuthFormItem = React.memo<
  React.ComponentProps<typeof AntForm.Item>
>(function authFormItem({
  children,
  ...props
}: React.ComponentProps<typeof AntForm.Item>) {
  return (
    <FormItemBase
      labelCol={{ offset: 4, span: 16 }}
      wrapperCol={{ offset: 4, span: 16 }}
      {...props}
    >
      {children}
    </FormItemBase>
  )
})
